import React, { useState, useEffect } from "react";
import {
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  InputAdornment,
  useTheme,
  useMediaQuery,
  Box,
  Typography,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import AddBoxIcon from "@mui/icons-material/AddBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolIcon from "@mui/icons-material/School";
import WorkIcon from "@mui/icons-material/Work";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import "./DynamicTableStyle.css";
import { DateRangePicker } from "materialui-daterange-picker";
import Checkbox from "@mui/material/Checkbox";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { updateSnackbar } from "../../_redux/SnackbarSlice";
import { useDispatch } from "react-redux";
import { DashboardPlusicon } from "../../Icons/DashboardPlusicon";

const ApplicantsDynamicTable = ({
  data,
  columns,
  componentType,
  typeofTable,
  receiveProps,
  showNewButton = false,
}) => {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [tableData, setTableData] = useState([]);
  const [tableRawData, setTableRawData] = useState([]);
  const [isDisableActions, setIsDisableActions] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [dateRange, setDateRange] = React.useState({});

  const toggle = () => setOpen(!open);
  const dispatch = useDispatch();

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      const formattedData = data.map((list) => {
        const locationFormated =
          list.locationFormated || list?.location?.formatted || "";
        const startDate =
          list?.experienceInMonths?.startDate || list?.startDate || "";
        const endDate = list?.experienceInMonths
          ? list.experienceInMonths.isCurrent
            ? ""
            : list.experienceInMonths.endDate || list.endDate || ""
          : list?.endDate || "";
        const isCurrent =
          list?.experienceInMonths?.isCurrent ?? list?.isCurrent ?? false;
        const start = startDate ? getFormatedDate(dayjs(startDate)) : "";
        const end = endDate ? getFormatedDate(dayjs(endDate)) : "";
        const duration =
          start || end ? `${start}${end ? " - " + end : ""}` : "";
        return {
          ...list,
          locationFormated,
          startDate,
          endDate,
          isCurrent,
          duration,
        };
      });
      setTableData(formattedData);
      setTableRawData(formattedData);
    }
  }, [data]);

  useEffect(() => {
    console.log("isDisableActions", isDisableActions);
    console.log("dateRange", dateRange);
  }, [isDisableActions, dateRange]);

  useEffect(() => {
    if (tableData.length > 0) {
      console.log("tableData", tableData);
      console.log("tableRawData", tableRawData);
      let isFlag = tableData?.filter((x) => x.isEdit === true);
      if (isFlag.length > 0) {
        setIsDisableActions(true);
      } else {
        setIsDisableActions(false);
      }
    }
  }, [tableData, tableRawData]);

  const onTableHandler = (item, type) => {
    let Array = JSON.parse(JSON.stringify(tableData));
    let Index = Array.findIndex((x) => x.id === item.id);
    if (type === "edit") {
      if (Index !== -1) {
        Array[Index].isEdit = true;
        setTableData(Array);
      }
    } else if (type === "isCurrent") {
      if (Index !== -1) {
        Array[Index].isCurrent = !Array[Index].isCurrent;
        if (Array[Index].experienceInMonths) {
          Array[Index].experienceInMonths.isCurrent = Array[Index].isCurrent;
          Array[Index].experienceInMonths.endDate = "";
        }
        if (Array[Index].isCurrent === true) {
          Array[Index].endDate = "- present";
          Array[Index].duration = `${Array[Index].startDate} - present`;
        } else {
          Array[Index].endDate = "";
          Array[Index].duration = "";
        }
        setTableData(Array);
      }
    } else if (type === "delete") {
      if (Index !== -1) {
        setIsDisableActions(false);
        Array.splice(Index, 1);
        setTableData(Array);
        setTableRawData(Array);
        receiveProps(Array);
      }
    } else if (type === "cancel") {
      let Array1 = JSON.parse(JSON.stringify(tableRawData));
      Array1.forEach((e) => {
        e.isEdit = false;
      });
      setIsDisableActions(false);
      setTableData(Array1);
    } else if (type === "save") {
      if (Index !== -1) {
        Array[Index].isEdit = false;
        if (typeofTable === "educationDetails") {
          if (
            (Array[Index].degree !== undefined && Array[Index].degree !== "") ||
            (Array[Index].organization !== undefined &&
              Array[Index].organization !== "") ||
            (Array[Index].duration !== undefined &&
              Array[Index].duration !== "") ||
            (Array[Index].locationFormated !== undefined &&
              Array[Index].locationFormated !== "")
          ) {
            setTableRawData(Array);
            setTableData(Array);
            receiveProps(Array);
          } else {
            onTableHandler(item, "delete");
          }
        } else if (typeofTable === "workExp") {
          if (
            (Array[Index].jobTitle !== undefined &&
              Array[Index].jobTitle !== "") ||
            (Array[Index].organization !== undefined &&
              Array[Index].organization !== "") ||
            (Array[Index].duration !== undefined &&
              Array[Index].duration !== "" &&
              Array[Index].startDate !== "") ||
            (Array[Index].empType !== undefined && Array[Index].empType !== "")
          ) {
            setTableRawData(Array);
            setTableData(Array);
            receiveProps(Array);
          } else if (Array[Index].startDate === "") {
            dispatch(
              updateSnackbar({
                type: "error",
                message: "Please select valid date",
              }),
            );
          } else {
            onTableHandler(item, "delete");
          }
        }
      }
    }
  };

  const handleDateChange = (date, data) => {
    let Array = JSON.parse(JSON.stringify(tableData));
    let Index = Array.findIndex((x) => x.id === data.id);
    if (Index !== -1) {
      Array[Index].startDate = date.startDate.toLocaleDateString();
      Array[Index].endDate = date.endDate.toLocaleDateString();
      Array[Index].duration = JSON.stringify(date);
      if (Array[Index].experienceInMonths) {
        Array[Index].experienceInMonths.startDate =
          date.startDate.toLocaleDateString();
        Array[Index].experienceInMonths.endDate =
          date.endDate.toLocaleDateString();
        Array[Index].experienceInMonths.isCurrent = false;
        Array[Index].experienceInMonths.rawText = "";
      }
      setOpen(false);
      setTableData(Array);
    }
  };

  const onChangeHandler = (value, label, obj) => {
    let Array = JSON.parse(JSON.stringify(tableData));
    let Index = Array.findIndex((x) => x.id === obj.id);
    if (Index !== -1) {
      if (label === "degree") {
        Array[Index]["education"] = value;
      }
      Array[Index][label] = value;
      setTableData(Array);
    }
  };

  const addRowHandler = () => {
    let tempArray = JSON.parse(JSON.stringify(tableData));
    if (tempArray.length === 1) {
      const fieldsToCheck = [
        "duration",
        "education",
        "endDate",
        "location",
        "locationFormated",
        "startDate",
      ];
      const isRowEmpty = fieldsToCheck.every((key) => {
        const val = tempArray[0][key];
        return val === "" || val === null || val === undefined;
      });
      if (isRowEmpty) {
        tempArray = [];
        setTableRawData([]);
      }
    }
    const newObj = Object.fromEntries(
      columns
        .filter((col) => col.displayName !== "Action")
        .map((col) => [col.name, ""]),
    );
    newObj["isEdit"] = true;
    newObj["id"] =
      tempArray.length > 0 ? tempArray[tempArray.length - 1].id + 1 : 1;
    newObj["startDate"] = "";
    newObj["endDate"] = "";
    newObj["isCurrent"] = false;
    setIsDisableActions(true);
    tempArray.push(newObj);
    setTableData(tempArray);
  };

  const getFormatedDate = (date) => {
    if (!(date instanceof Date)) {
      return "";
    }
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const parseDateForPicker = (dateStr) => {
    if (!dateStr || dateStr === "- present") return null;
    if (typeof dateStr === "string" && dateStr.includes("/")) {
      const parts = dateStr.split("/");
      if (parts.length === 3) {
        return dayjs(new Date(parts[2], parts[1] - 1, parts[0]));
      }
    }
    return dayjs(dateStr);
  };

  const onStartDateChangeHandler = (value, obj) => {
    let Array = JSON.parse(JSON.stringify(tableData));
    let Index = Array.findIndex((x) => x.id === obj.id);
    if (Index !== -1) {
      Array[Index].startDate = getFormatedDate(value.toDate());
      Array[Index].endDate = "- present";
      Array[Index].duration = `${Array[Index].startDate} - present`;
      if (Array[Index].experienceInMonths) {
        Array[Index].experienceInMonths.startDate = `${Array[Index].startDate}`;
        Array[Index].experienceInMonths.endDate = "- present";
        Array[Index].experienceInMonths.isCurrent = true;
      }
      setTableData(Array);
    }
  };

  return (
    <>
      {componentType !== "view" ? (
        <IconButton
          color="primary"
          className="addRow"
          disabled={isDisableActions}
          onClick={addRowHandler}
          component="label"
        >
          {showNewButton ? (
            <DashboardPlusicon width={35} height={36} />
          ) : (
            <AddBoxIcon style={{ color: "#8e8e8e", fontSize: "31px" }} />
          )}
        </IconButton>
      ) : (
        ""
      )}
      <TableContainer component={Paper}>
        <Table
          id="inlineEditTable"
          aria-label="customized table"
          sx={{ tableLayout: "fixed", width: "100%" }}
        >
          <TableHead>
            <TableRow>
              {isMobile ? (
                <StyledTableCell
                  className="applicantdynatablehead"
                  width="100%"
                >
                  {typeofTable === "educationDetails"
                    ? "Education"
                    : typeofTable === "workExp"
                      ? "Experience"
                      : "Details"}
                </StyledTableCell>
              ) : (
                columns.map((col) => {
                  return (
                    <StyledTableCell
                      className="applicantdynatablehead"
                      width={
                        col?.width
                          ? col?.width
                          : col.displayName === "Action"
                            ? "10%"
                            : "20%"
                      }
                    >
                      {col.displayName}{" "}
                    </StyledTableCell>
                  );
                })
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.length > 0 ? (
              <>
                {tableData &&
                  tableData.map((data, index) => {
                    if (data.isEdit === false) {
                      return (
                        <StyledTableRow>
                          {isMobile ? (
                            <StyledTableCell
                              width="100%"
                              colSpan={columns.length}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 1,
                                  p: 2,
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      gap: 1.5,
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <Box sx={{ color: "action.active" }}>
                                      {typeofTable === "educationDetails" ? (
                                        <SchoolIcon />
                                      ) : (
                                        <WorkIcon />
                                      )}
                                    </Box>
                                    <Box>
                                      <Typography
                                        variant="body1"
                                        sx={{
                                          fontWeight: 600,
                                          color: "#333",
                                          lineHeight: 1.2,
                                          mb: 0.5,
                                        }}
                                      >
                                        {typeofTable === "educationDetails"
                                          ? data.degree
                                          : data.jobTitle}
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "text.secondary",
                                          fontWeight: 500,
                                        }}
                                      >
                                        {data.organization}
                                      </Typography>
                                    </Box>
                                  </Box>
                                  {componentType !== "view" && (
                                    <Box sx={{ display: "flex", gap: 1 }}>
                                      <IconButton
                                        size="small"
                                        disabled={isDisableActions}
                                        onClick={() =>
                                          onTableHandler(data, "edit")
                                        }
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                      <IconButton
                                        size="small"
                                        disabled={isDisableActions}
                                        onClick={() =>
                                          onTableHandler(data, "delete")
                                        }
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Box>
                                  )}
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.5,
                                  }}
                                >
                                  {(data.startDate || data.endDate) && (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                      }}
                                    >
                                      <CalendarTodayIcon
                                        sx={{
                                          fontSize: "1rem",
                                          color: "text.secondary",
                                          ml: 0.5,
                                        }}
                                      />
                                      <Typography
                                        variant="body2"
                                        sx={{ color: "text.secondary" }}
                                      >
                                        {data.isCurrent
                                          ? data.startDate
                                            ? data.startDate + " - present"
                                            : ""
                                          : data.startDate && data.endDate
                                            ? `${data.startDate} - ${data.endDate}`
                                            : data.startDate ||
                                              `- ${data.endDate}` ||
                                              ""}
                                      </Typography>
                                    </Box>
                                  )}
                                  {data.locationFormated &&
                                    typeofTable === "educationDetails" && (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                        }}
                                      >
                                        <LocationOnIcon
                                          sx={{
                                            fontSize: "1rem",
                                            color: "text.secondary",
                                            ml: 0.5,
                                          }}
                                        />
                                        <Typography
                                          variant="body2"
                                          sx={{ color: "text.secondary" }}
                                        >
                                          {data.locationFormated}
                                        </Typography>
                                      </Box>
                                    )}
                                  {data.empType &&
                                    typeofTable === "workExp" && (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                        }}
                                      >
                                        <WorkIcon
                                          sx={{
                                            fontSize: "1rem",
                                            color: "text.secondary",
                                            ml: 0.5,
                                          }}
                                        />
                                        <Typography
                                          variant="body2"
                                          sx={{ color: "text.secondary" }}
                                        >
                                          {data.empType}
                                        </Typography>
                                      </Box>
                                    )}
                                </Box>
                              </Box>
                            </StyledTableCell>
                          ) : (
                            columns.map((col) => {
                              if (
                                col.displayName !== "Action" &&
                                col.displayName !== "Duration"
                              ) {
                                return (
                                  <StyledTableCell
                                    width={col?.width ? col?.width : "20%"}
                                  >
                                    <div className="rowHeight">
                                      {data[col.name]}
                                    </div>{" "}
                                  </StyledTableCell>
                                );
                              } else if (
                                col.displayName !== "Action" &&
                                col.displayName === "Duration" &&
                                data.isCurrent === true
                              ) {
                                return (
                                  <StyledTableCell
                                    width={col?.width ? col?.width : "20%"}
                                  >
                                    {data.startDate
                                      ? data.startDate + "- present"
                                      : ""}{" "}
                                  </StyledTableCell>
                                );
                              } else if (
                                col.displayName !== "Action" &&
                                col.displayName === "Duration" &&
                                data.isCurrent === false
                              ) {
                                return (
                                  <StyledTableCell
                                    width={col?.width ? col?.width : "20%"}
                                  >
                                    {data.startDate && data.endDate
                                      ? `${data.startDate} - ${data.endDate}`
                                      : data.startDate ||
                                        `- ${data.endDate}` ||
                                        ""}
                                  </StyledTableCell>
                                );
                              } else {
                                if (
                                  componentType !== "view" &&
                                  col.displayName === "Action"
                                ) {
                                  return (
                                    <StyledTableCell
                                      width={col?.width ? col?.width : "75%"}
                                    >
                                      <IconButton
                                        color="primary"
                                        disabled={isDisableActions}
                                        onClick={() =>
                                          onTableHandler(data, "edit")
                                        }
                                        component="label"
                                      >
                                        {col.name === "newIcon" ? (
                                          <img
                                            src={
                                              process.env.PUBLIC_URL +
                                              "/assests/img/edit-icon-dynamictable.svg"
                                            }
                                            alt="edit icon"
                                            width="17px"
                                          />
                                        ) : (
                                          <EditIcon
                                            style={{ color: "#8e8e8e" }}
                                            className="appediticon"
                                          />
                                        )}
                                      </IconButton>
                                      <IconButton
                                        color="primary"
                                        disabled={isDisableActions}
                                        onClick={() =>
                                          onTableHandler(data, "delete")
                                        }
                                        component="label"
                                      >
                                        {col.name === "newIcon" ? (
                                          <img
                                            src={
                                              process.env.PUBLIC_URL +
                                              "/assests/img/delete-icon-dynamictable.svg"
                                            }
                                            alt="edit icon"
                                            width="17px"
                                          />
                                        ) : (
                                          <DeleteIcon
                                            style={{ color: "#8e8e8e" }}
                                            className="appdeleteicon"
                                          />
                                        )}
                                      </IconButton>
                                    </StyledTableCell>
                                  );
                                } else {
                                  return <StyledTableCell> </StyledTableCell>;
                                }
                              }
                            })
                          )}
                        </StyledTableRow>
                      );
                    } else if (data.isEdit === true) {
                      return (
                        <>
                          <StyledTableRow
                            valign="top"
                            className={`
                              ${typeofTable === "workExp" ? "educationTableWorkExp" : ""}
                              ${data.isEdit ? "no-bg" : ""}
                            `}
                          >
                            {isMobile ? (
                              <StyledTableCell
                                width="100%"
                                colSpan={columns.length}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 2,
                                    // p: 2,
                                  }}
                                >
                                  {columns.map((col) => {
                                    if (
                                      col.name !== "duration" &&
                                      col.displayName !== "Action"
                                    ) {
                                      return (
                                        <Box
                                          key={col.name}
                                          sx={{ width: "100%" }}
                                        >
                                          <TextField
                                            // size="small"
                                            id={`outlined-basic-${col.name}`}
                                            variant="outlined"
                                            autoComplete="off"
                                            placeholder={col.displayName}
                                            style={{ width: "100%" }}
                                            name={col.name}
                                            value={data[col.name]}
                                            onChange={(e) => {
                                              onChangeHandler(
                                                e.target.value,
                                                col.name,
                                                data,
                                              );
                                            }}
                                          />
                                          {typeofTable === "workExp" &&
                                            col.displayName === "Title" && (
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  mt: 1,
                                                }}
                                              >
                                                <Checkbox
                                                  {...label}
                                                  className="checkboxapplicants"
                                                  checked={data.isCurrent}
                                                  onClick={() =>
                                                    onTableHandler(
                                                      data,
                                                      "isCurrent",
                                                    )
                                                  }
                                                />
                                                <Typography
                                                  variant="body2"
                                                  sx={{ m: 0 }}
                                                >
                                                  I am currently working on this
                                                  role
                                                </Typography>
                                              </Box>
                                            )}
                                        </Box>
                                      );
                                    } else if (col.name === "duration") {
                                      return (
                                        <Box
                                          key={col.name}
                                          sx={{ width: "100%" }}
                                        >
                                          {data.isCurrent === true ? (
                                            <Box
                                              className="isCurrentSection"
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                              }}
                                            >
                                              <LocalizationProvider
                                                dateAdapter={AdapterDayjs}
                                              >
                                                <DatePicker
                                                  className="customPicker"
                                                  name={col.name}
                                                  variant="outlined"
                                                  autoComplete="off"
                                                  label="Start Date"
                                                  slotProps={
                                                    {
                                                      // textField: {
                                                      //   size: "small",
                                                      // },
                                                    }
                                                  }
                                                  value={parseDateForPicker(
                                                    data.startDate,
                                                  )}
                                                  onChange={(date) =>
                                                    onStartDateChangeHandler(
                                                      date,
                                                      data,
                                                    )
                                                  }
                                                  sx={{ width: "100%" }}
                                                />
                                              </LocalizationProvider>
                                              <Typography
                                                variant="body2"
                                                sx={{ whiteSpace: "nowrap" }}
                                              >
                                                - present
                                              </Typography>
                                            </Box>
                                          ) : (
                                            <Box
                                              className="mobile-date-picker"
                                              sx={{ width: "100%" }}
                                            >
                                              <LocalizationProvider
                                                dateAdapter={AdapterDayjs}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "15px",
                                                  }}
                                                >
                                                  <DatePicker
                                                    className="customPicker"
                                                    name={col.name + "_start"}
                                                    variant="outlined"
                                                    autoComplete="off"
                                                    label="Start Date"
                                                    slotProps={{
                                                      textField: {
                                                        // size: "small",
                                                        InputProps: {
                                                          startAdornment: (
                                                            <InputAdornment position="start">
                                                              <CalendarTodayIcon
                                                                style={{
                                                                  fontSize:
                                                                    "1rem",
                                                                }}
                                                              />
                                                            </InputAdornment>
                                                          ),
                                                        },
                                                      },
                                                    }}
                                                    slots={{
                                                      openPickerIcon: () =>
                                                        null,
                                                    }}
                                                    value={parseDateForPicker(
                                                      data.startDate,
                                                    )}
                                                    onChange={(date) => {
                                                      let Array = JSON.parse(
                                                        JSON.stringify(
                                                          tableData,
                                                        ),
                                                      );
                                                      let Index =
                                                        Array.findIndex(
                                                          (x) =>
                                                            x.id === data.id,
                                                        );
                                                      if (
                                                        Index !== -1 &&
                                                        date
                                                      ) {
                                                        let dt =
                                                          getFormatedDate(
                                                            date.toDate(),
                                                          );
                                                        Array[Index].startDate =
                                                          dt;
                                                        let endStr =
                                                          Array[Index]
                                                            .endDate &&
                                                          Array[Index]
                                                            .endDate !==
                                                            "- present"
                                                            ? ` - ${Array[Index].endDate}`
                                                            : "";
                                                        Array[Index].duration =
                                                          dt + endStr;
                                                        if (
                                                          Array[Index]
                                                            .experienceInMonths
                                                        ) {
                                                          Array[
                                                            Index
                                                          ].experienceInMonths.startDate =
                                                            dt;
                                                        }
                                                        setTableData(Array);
                                                      }
                                                    }}
                                                    sx={{ width: "100%" }}
                                                  />
                                                  <DatePicker
                                                    className="customPicker"
                                                    name={col.name + "_end"}
                                                    variant="outlined"
                                                    autoComplete="off"
                                                    label="End Date"
                                                    slotProps={{
                                                      textField: {
                                                        // size: "small",
                                                        InputProps: {
                                                          startAdornment: (
                                                            <InputAdornment position="start">
                                                              <CalendarTodayIcon
                                                                style={{
                                                                  fontSize:
                                                                    "1rem",
                                                                }}
                                                              />
                                                            </InputAdornment>
                                                          ),
                                                        },
                                                      },
                                                    }}
                                                    slots={{
                                                      openPickerIcon: () =>
                                                        null,
                                                    }}
                                                    value={parseDateForPicker(
                                                      data.endDate,
                                                    )}
                                                    onChange={(date) => {
                                                      let Array = JSON.parse(
                                                        JSON.stringify(
                                                          tableData,
                                                        ),
                                                      );
                                                      let Index =
                                                        Array.findIndex(
                                                          (x) =>
                                                            x.id === data.id,
                                                        );
                                                      if (
                                                        Index !== -1 &&
                                                        date
                                                      ) {
                                                        let dt =
                                                          getFormatedDate(
                                                            date.toDate(),
                                                          );
                                                        Array[Index].endDate =
                                                          dt;
                                                        let startStr = Array[
                                                          Index
                                                        ].startDate
                                                          ? Array[Index]
                                                              .startDate
                                                          : "";
                                                        Array[Index].duration =
                                                          startStr +
                                                          (dt
                                                            ? ` - ${dt}`
                                                            : "");
                                                        if (
                                                          Array[Index]
                                                            .experienceInMonths
                                                        ) {
                                                          Array[
                                                            Index
                                                          ].experienceInMonths.endDate =
                                                            dt;
                                                        }
                                                        setTableData(Array);
                                                      }
                                                    }}
                                                    sx={{ width: "100%" }}
                                                  />
                                                </Box>
                                              </LocalizationProvider>
                                            </Box>
                                          )}
                                        </Box>
                                      );
                                    }
                                    return null;
                                  })}
                                  {componentType !== "view" && (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        mt: 1,
                                      }}
                                    >
                                      <IconButton
                                        style={{
                                          verticalAlign: "text-top",
                                          paddingTop: "7px",
                                          paddingRight: "3px",
                                        }}
                                        color="primary"
                                        onClick={() =>
                                          onTableHandler(data, "save")
                                        }
                                        component="label"
                                      >
                                        <DoneIcon style={{ color: "#000" }} />
                                      </IconButton>
                                      <IconButton
                                        style={{ verticalAlign: "text-top" }}
                                        color="primary"
                                        onClick={() =>
                                          onTableHandler(data, "cancel")
                                        }
                                        component="label"
                                      >
                                        <CloseIcon style={{ color: "#000" }} />
                                      </IconButton>
                                    </Box>
                                  )}
                                </Box>
                              </StyledTableCell>
                            ) : (
                              columns.map((col) => {
                                if (
                                  col.name !== "duration" &&
                                  col.displayName !== "Action"
                                ) {
                                  return (
                                    <StyledTableCell
                                      valign="top"
                                      width={col?.width ? col?.width : ""}
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        autoComplete="off"
                                        placeholder={col.displayName}
                                        style={{ width: "100%" }}
                                        name={col.name}
                                        value={data[col.name]}
                                        onChange={(e) => {
                                          onChangeHandler(
                                            e.target.value,
                                            col.name,
                                            data,
                                          );
                                        }}
                                      />
                                      <>
                                        {typeofTable === "workExp" &&
                                        col.displayName === "Title" ? (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Checkbox
                                              {...label}
                                              className="checkboxapplicants"
                                              checked={data.isCurrent}
                                              onClick={() =>
                                                onTableHandler(
                                                  data,
                                                  "isCurrent",
                                                )
                                              }
                                            />
                                            <p
                                              style={{
                                                margin: 0,
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              I am currently working on this
                                              role
                                            </p>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    </StyledTableCell>
                                  );
                                } else if (col.name === "duration") {
                                  return (
                                    <StyledTableCell
                                      valign="top"
                                      width={col?.width ? col?.width : ""}
                                    >
                                      {data.isCurrent === true ? (
                                        <div className="isCurrentSection">
                                          <LocalizationProvider
                                            dateAdapter={AdapterDayjs}
                                          >
                                            <DatePicker
                                              className="customPicker"
                                              name={col.name}
                                              variant="outlined"
                                              autoComplete="off"
                                              value={parseDateForPicker(
                                                data.startDate,
                                              )}
                                              onChange={(date) =>
                                                onStartDateChangeHandler(
                                                  date,
                                                  data,
                                                )
                                              }
                                              style={{
                                                height: "3.5rem",
                                                borderRadius: "4px",
                                              }}
                                            />
                                          </LocalizationProvider>
                                          <span
                                            style={{
                                              verticalAlign: "bottom",
                                              display: "inline-block",
                                              margin: "0 0 19px 18px",
                                            }}
                                          >
                                            {" "}
                                            - present
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="educationTermRangePicker">
                                          <div>
                                            <TextField
                                              id="outlined-basic"
                                              variant="outlined"
                                              autoComplete="off"
                                              placeholder="Start Date"
                                              style={{ width: "50%" }}
                                              name={col.name}
                                              value={data.startDate}
                                              onClick={(e) => {
                                                setOpen(true);
                                              }}
                                            />
                                            <TextField
                                              id="outlined-basic"
                                              variant="outlined"
                                              autoComplete="off"
                                              placeholder="End Date"
                                              style={{ width: "50%" }}
                                              name={col.name}
                                              value={data.endDate}
                                              onClick={(e) => {
                                                setOpen(true);
                                              }}
                                            />
                                          </div>
                                          <DateRangePicker
                                            open={open}
                                            toggle={toggle}
                                            minDate={new Date("1-1-1800")}
                                            autoComplete="off"
                                            onChange={(range) => {
                                              setDateRange(range);
                                              handleDateChange(range, data);
                                            }}
                                          />
                                        </div>
                                      )}
                                    </StyledTableCell>
                                  );
                                } else {
                                  if (componentType !== "view") {
                                    return (
                                      <StyledTableCell
                                        width={col?.width ? col?.width : ""}
                                      >
                                        <IconButton
                                          style={{
                                            verticalAlign: "text-top",
                                            paddingTop: "7px",
                                            paddingRight: "3px",
                                          }}
                                          color="primary"
                                          onClick={() =>
                                            onTableHandler(data, "save")
                                          }
                                          component="label"
                                        >
                                          <DoneIcon
                                            style={{
                                              color:
                                                col.name === "newIcon"
                                                  ? "#000"
                                                  : "#8e8e8e",
                                            }}
                                          />
                                        </IconButton>
                                        <IconButton
                                          style={{ verticalAlign: "text-top" }}
                                          color="primary"
                                          onClick={() =>
                                            onTableHandler(data, "cancel")
                                          }
                                          component="label"
                                        >
                                          <CloseIcon
                                            style={{
                                              color:
                                                col.name === "newIcon"
                                                  ? "#000"
                                                  : "#8e8e8e",
                                            }}
                                          />
                                        </IconButton>
                                      </StyledTableCell>
                                    );
                                  } else {
                                    return <StyledTableCell> </StyledTableCell>;
                                  }
                                }
                              })
                            )}
                          </StyledTableRow>
                        </>
                      );
                    }
                  })}
              </>
            ) : (
              ""
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default React.memo(ApplicantsDynamicTable);

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    borderRight: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  // "&:last-child td, &:last-child th": {
  //   borderRight: "1px solid #E8E8E8",
  // },
}));
